// extracted by mini-css-extract-plugin
export default {"table":"table__mlXd2G","projectsOverview":"projectsOverview__mrlBIx"};